export const TICKETS_RESET_STATE = 'TICKETS_RESET_STATE';
export const TICKETS_CURRENT_ITEM = 'TICKETS_CURRENT_ITEM';

export const TICKETS_REQUEST_LOADING = 'TICKETS_REQUEST_LOADING';
export const TICKETS_REQUEST_SUCCESS = 'TICKETS_REQUEST_SUCCESS';
export const TICKETS_REQUEST_FAILED = 'TICKETS_REQUEST_FAILED';

export const TICKETS_CURRENT_ACTION = 'TICKETS_CURRENT_ACTION';
export const TICKETS_RESET_ACTION = 'TICKETS_RESET_ACTION';
